import React from 'react'
import I18n from "lib/i18n/i18n"
import PopupHelp from "../popups/popupHelp"
import { useSelector } from "react-redux"
import { MediumLinkButton } from "@worthy-npm/clarity"
import { isMobile } from "../../helpers/ApplicationHelper"
import { useAppointment } from "../../hooks/useAppointment"


const PageBlocked = () => {

    const { ADO } = useSelector(state => state)
    const { data }  = useAppointment(ADO?.user?.id)

    const onClick = () => {
        if (ADO.workingHour) {
            window.location = `tel:${data?.objectType === 'High Value' ? I18n.getString('common::vipPhoneNumber') : I18n.getString('common::phoneNumber')}`
        } else {
            PopupHelp.initPopup({single: true, modal: true});
        }
    }

    const callCanceled = () => {
        return window.location.pathname.includes('call-canceled')
    }


    return(
        <div className={'page-blocked'}>
            { callCanceled() ? I18n.getString('manageCall::callDetails::callCanceled') : I18n.getString('manageCall::callDetails::appointmentNotExistsMsg') }
            <div className={'phone'}>
            { isMobile() ? <MediumLinkButton text={I18n.getString('common::phoneNumberString')} click={() => onClick()} />
                : <div>{I18n.getString('common::phoneNumberString')}</div>
            }
            </div>
        </div>
    )
}

export default PageBlocked
